import { IcsCalendars } from '../../models';

export interface State {
  data: IcsCalendars;
  isLoading?: boolean;
  error?: any;
}

export const initialState: State = {
  data: null,
  isLoading: false,
  error: null,
};
